module.exports = {["template-viewer-branding"]: function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n	<div class="rm-branding offscreen-initially">\n	<a class="rm-branding-button" href="https://readymag.com" target="_blank"></a>\n	</div>\n';
}
return __p;
},}